import React from "react";
import Header from "../../components/Header";
import Contacts from "../../components/Contacts";
import Footer from "../../components/Footer";
const Home = () => {
  return (
    <>
      <Header />
      <Contacts />
      <Footer />
    </>
  );
};

export default Home;
